import {
    Component,
    Input,
    ViewChild,
    ChangeDetectionStrategy,
} from '@angular/core';
import { QuickFilterComponent } from './components/quick-filter/quick-filter.component';
import { ExportCsvComponent } from './components/export-csv/export-csv.component';
import { ClearFiltersComponent } from './components/clear-filters/clear-filters.component';
import { GridApi } from 'ag-grid-community';
import { GridToolbarOptions } from './models/grid-toolbar-options';
import { GridHelper } from '../../../../core/models/grid/grid-helper';
import { PrimaryGridActionComponent } from './components/primary-grid-action/primary-grid-action.component';

@Component({
    selector: 'app-grid-toolbar',
    imports: [
        QuickFilterComponent,
        ExportCsvComponent,
        ClearFiltersComponent,
        PrimaryGridActionComponent,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './grid-toolbar.component.html',
})
export class GridToolbarComponent {
    @Input() gridApi: GridApi | undefined;
    @Input() options: GridToolbarOptions = GridHelper.defaultToolbarOptions;

    @ViewChild(QuickFilterComponent) quickFilter?: QuickFilterComponent;

    public hasToolbarOptions(): boolean {
        return (
            this.options.quickFilter ||
            this.options.exportCsv ||
            this.shouldShowClearFilters() ||
            !!this.options.primaryGridAction
        );
    }

    public onFiltersCleared(): void {
        this.quickFilter?.clearInput();
    }

    public shouldShowClearFilters(): boolean {
        if (!this.options.clearFilters || !this.gridApi) {
            return false;
        }

        const columns = this.gridApi.getColumns();
        if (!columns?.length) {
            return false;
        }

        return columns.some((column) => column.isFilterAllowed());
    }
}
